import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IUserLog } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class UsersLogsApiClient extends BaseApiClient<IUserLog, any, FilterQuery<IUserLog>, IUserLog, IUserLog> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.usersLogs}`
    super({
      apiUrl: baseUrl,
      axios
    })
  }
}